export default __webpack_public_path__ + "img/favicons/apple-touch-icon-57x57.png";